export { default } from './InputBase';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/InputBase/index.js
// module id = 315
// module chunks = 121